export const RadioGroupTestPageObject = (value: undefined | string, handleChange: (value: string) => void) => ({
    getType: () => "RadioGroup",

    getValue: () => value,

    setValue: (nextValue: string) => handleChange(nextValue),
});
